import { computed, useStore } from '@nuxtjs/composition-api'

export const usePreviousUrl = () => {
  const store = useStore()
  return computed(() => {
    if (document.referrer) return document.referrer
    const prevRoute = store.getters['router/getPrevRoute']
    if (prevRoute?.fullPath) return window.location.origin + prevRoute.fullPath
    return ''
  })
}
